module.exports = __webpack_public_path__ + "img/stop-point.f93084b2.svg";